export default __webpack_public_path__ + "2b37fa52433155e53156027868143c2e.woff";